export default class DocumentModel {
  filename: string | null;
  url: string | null;
  downloadUrl: string | null;
  physicalPath: string | null;

  constructor(
    filename: string | null,
    url: string | null,
    downloadUrl: string | null,
    physicalPath: string | null
  ) {
    this.filename = filename;
    this.url = url;
    this.downloadUrl = downloadUrl;
    this.physicalPath = physicalPath;
  }

  static fromApiResponse(data: any): DocumentModel {
    return new DocumentModel(
      data.filename || null,
      data.url || null,
      data.downloadUrl || null,
      data.physicalPath || null,
    );
  }

  static fromApiResponseArray(dataArray: any[]): DocumentModel[] {
    return dataArray.map((data) => DocumentModel.fromApiResponse(data));
  }
}
